import React from 'react';

interface CatalogIconProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean; // наше кастомное поле
}

function CatalogIcon({ isActive = false, ...props }: CatalogIconProps) {
  return isActive ? (
    <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.66675 2.83329L0.666748 2.83333V1.16666L5.66675 1.16663V2.83329ZM5.66675 6.16666H0.666748V7.83333H5.66675V6.16666ZM17.4084 11.5833L13.8001 7.975C13.0834 8.44166 12.2251 8.70833 11.3001 8.65833C9.32508 8.56666 7.63342 7.025 7.36675 5.06666C7.00008 2.275 9.40842 -0.0833367 12.2251 0.391663C13.8501 0.666663 15.2001 1.93333 15.5584 3.54166C15.8334 4.75833 15.5667 5.89166 14.9751 6.79166L18.5917 10.4083L17.4084 11.5833ZM14.0001 4.5C14.0001 3.125 12.8751 2 11.5001 2C10.1251 2 9.00008 3.125 9.00008 4.5C9.00008 5.875 10.1251 7 11.5001 7C12.8751 7 14.0001 5.875 14.0001 4.5ZM0.666748 12.8333H13.1667V11.1667H0.666748V12.8333Z" fill="#FC8181" />
    </svg>

  ) : (
    <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.7666 2.83329L0.766602 2.83333V1.16666L5.7666 1.16663V2.83329ZM5.7666 6.16666H0.766602V7.83333H5.7666V6.16666ZM17.5082 11.5833L13.8999 7.975C13.1833 8.44166 12.3249 8.70833 11.3999 8.65833C9.42494 8.56666 7.73327 7.025 7.4666 5.06666C7.09994 2.275 9.50827 -0.0833367 12.3249 0.391663C13.9499 0.666663 15.2999 1.93333 15.6583 3.54166C15.9333 4.75833 15.6666 5.89166 15.0749 6.79166L18.6916 10.4083L17.5082 11.5833ZM14.0999 4.5C14.0999 3.125 12.9749 2 11.5999 2C10.2249 2 9.09994 3.125 9.09994 4.5C9.09994 5.875 10.2249 7 11.5999 7C12.9749 7 14.0999 5.875 14.0999 4.5ZM0.766602 12.8333H13.2666V11.1667H0.766602V12.8333Z" fill="#1E1E1E" />
    </svg>

  )
}

export default CatalogIcon;
